import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const timeeldConfig: TSPConfig = {
  key: 'timeeld',
  name: 'Time ELD',
  imageName: 'TimeELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Time ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default timeeldConfig;
